import CopyableField from './copyable_field.vue?vue3';
export default {
    name: 'CopyEmailToClipboard',
    components: {
        CopyableField
    },
    props: {
        issueEmailAddress: {
            type: String,
            required: true
        }
    }
};
